import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "./AuthContext";
import HomePage from "./HomePage.jsx";
import Dashboard from "./Dashboard.jsx";
import Meetings from "./Meetings.jsx";
import Tasks from "./Tasks.jsx";
import ActionItems from "./ActionItems.jsx";
import Attendance from "./Attendance.jsx";
import Votes from "./Votes.jsx";
import Nominations from "./Nominations.jsx";
import Documents from "./Documents.jsx";
import ResourceLibrary from "./ResourceLibrary.jsx";
import MeetingMinutes from "./MeetingMinutes.jsx";
import Noticeboard from "./Noticeboard.jsx";
import MessageBoard from "./MessageBoard.jsx";
import Elections from "./Elections.jsx";
import MemberProfiles from "./MemberProfiles.jsx";
import CommitteeNotes from "./CommitteeNotes.jsx";
import Layout from "./Layout.jsx";
import Login from "./Login.jsx";

// Protected Route Wrapper
function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f7fafc",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              width: "60px",
              height: "60px",
              border: "4px solid #e2e8f0",
              borderTopColor: "#667eea",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              margin: "0 auto 20px",
            }}
          />
          <p style={{ color: "#718096", fontSize: "16px" }}>Loading...</p>
        </div>
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<HomePage />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="meetings" element={<Meetings />} />
            <Route path="tasks" element={<Tasks />} />
            <Route path="action-items" element={<ActionItems />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="votes" element={<Votes />} />
            <Route path="nominations" element={<Nominations />} />
            <Route path="documents" element={<Documents />} />
            <Route path="resources" element={<ResourceLibrary />} />
            <Route path="minutes" element={<MeetingMinutes />} />
            <Route path="committee-notes" element={<CommitteeNotes />} />
            <Route path="noticeboard" element={<Noticeboard />} />
            <Route path="messageboard" element={<MessageBoard />} />
            <Route path="elections" element={<Elections />} />
            <Route path="members" element={<MemberProfiles />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
